<div class="topbar-mobile" [ngClass]="{ 'hidden': isSidebarOpen }">
    <div class="autocomplete-wrapper">
        <i class="pi pi-bars search-icon" (click)="openSidebar()"></i>
        <p-autoComplete
            class="search-input-mobile"
            placeholder="{{ 'MAP.SEARCH.PLACEHOLDER' | translate }}"
            [(ngModel)]="searchQuery"
            [suggestions]="filteredResults"
            (completeMethod)="searchAddress($event)"
            field="display_name"
            [forceSelection]="true"
            (onSelect)="selectResult($event)"
        >
            <ng-template let-item pTemplate="item">
            <div>
                {{ item.display_name }}
            </div>
            </ng-template>
        </p-autoComplete>
    </div>
  </div>
  <app-sidebar #appSidebar></app-sidebar>
